export default __webpack_public_path__ + "locales/es/Ldap.json?hash=faf8b7360020b965fa3ac3749ca88b1c";